



import React from 'react';
import not from 'ramda/src/not';

import { ErrorPage } from '../containers/ErrorPage';
import { ROLLBAR_SERVER_TOKEN } from '../constants';
import { isRedirectException } from '../utils/api/isRedirectException';
import { HttpStatus } from '../constants/http-status';
import { isNotFoundException } from '../utils/api/isNotFoundException';

import { executionEnvironment } from '../wag-react/common/xenv';
import { rollbarSkipPaths } from '../utils/rollbarConfig';

const environment = process.env.NODE_ENV || 'unknown';

const Error = ({
  statusCode,
  message,
}) => (
  <ErrorPage
    statusCode={statusCode}
    message={message}
  />
);

Error.getInitialProps = ({
  req,
  res,
  err,
}) => {
  if (typeof window === 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const newrelic = require('newrelic');
    newrelic.noticeError(err);
  } else {
    window.newrelic.noticeError(err);
  }

  const statusCode = (err && err.statusCode ? err.statusCode : HttpStatus.INTERNAL_SERVER_ERROR);
  const errorExtras = err.extras || {};

  const skipLogging = rollbarSkipPaths.some(path => req?.url?.startsWith(path));
  const shouldSendToRollbar = [
    not(executionEnvironment.isBrowser),
    not(isNotFoundException(statusCode)), // do not send 404 errors
    not(skipLogging), // do not send errors from skipPaths
    (environment !== 'dev' && environment !== 'test'),
  ].every((result) => result === true);

  // Update response status code
  // by default, Next.js returns 500
  res.statusCode = statusCode;
  res.setHeader('Cache-Control', 'private,no-cache'); // Do not ever allow errors to be cached.

  if (isRedirectException(err.statusCode)) {
    res.writeHead(err.statusCode, {
      Location: errorExtras.location,
    });
    res.end();
    return {};
  }

  if (shouldSendToRollbar) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const Rollbar = require('rollbar');
    const rollbar = new Rollbar(ROLLBAR_SERVER_TOKEN);

    rollbar.error(err, req, (rollbarError) => {
      if (rollbarError) {
        console.error('Rollbar error reporting failed:');
        console.error(rollbarError);
      }
    });
  }

  return {
    statusCode,
    // Intentionally falling back to `err.message`. Do we need to log this on rollbar?
    message: 'An error occurred on server' || err.message,
  };
};

export default Error;
